import { useConfig } from '@exam-center/configuration';
import { type ExamCourseLanguage, type ExamCourseType } from '@exam-center/graphql';

import { CertificateTemplatePreviewer } from '../../components';
import { getCertificateTemplateImage, type TemplateValue } from '../../utils/certificate-templates';

interface FailCertificateTemplatePreviewerProps {
  examCourseType: ExamCourseType | null | undefined;
  examCourseLanguage: ExamCourseLanguage | null | undefined;
  variant: TemplateValue;
}

export default function FailCertificateTemplatePreviewer(
  props: Readonly<FailCertificateTemplatePreviewerProps>,
) {
  const { examCourseType, examCourseLanguage, variant } = props;
  const { mode } = useConfig();

  if (!examCourseType || !examCourseLanguage) {
    return null;
  }

  const previewSrc = getCertificateTemplateImage(
    'fail',
    examCourseType,
    examCourseLanguage,
    variant,
    mode,
    'preview',
  );

  const fullSrc = getCertificateTemplateImage(
    'fail',
    examCourseType,
    examCourseLanguage,
    variant,
    mode,
    'full',
  );

  return <CertificateTemplatePreviewer previewSrc={previewSrc} fullSrc={fullSrc} />;
}
